import React, { useEffect } from "react";
import WOW from "wowjs";
import "../../assets/lib/animate/animate.css";

const Offer = () => {
  useEffect(() => {
    // Inicializa WOW.js después de que el componente ha sido renderizado
    new WOW.WOW({
      live: false, // Para evitar la activación de animaciones en nuevos elementos añadidos dinámicamente
    }).init();
  }, []);

  return (
    <div
      className="container-fluid bg-offer my-5 py-5 wow fadeInUp"
      data-wow-delay="0.1s"
    >
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-7 wow zoomIn" data-wow-delay="0.6s">
            <div className="offer-text text-center rounded p-5">
              <h1 className="display-5 text-white">
                Ahorrá 10% en tu primera consulta
              </h1>
              <p className="text-white mb-4">
                Te atendemos y brindamos un servicio personalizado
              </p>
              <a href="/appointment" className="btn btn-dark py-3 px-5 me-3">
                Agendá tu turno
              </a>
              <a href="/about" className="btn btn-light py-3 px-5">
                Leer más
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Offer;